export default __webpack_public_path__ + "static/media/DropdownIcon.a9f00627.svg";